import React from 'react';
import { PropertyList, PlaceholderProperty } from './styles';
import { ProductCorePropertiesProps } from './types';

export const ProductCoreProperties = ({
  className,
  properties,
  toneDown = false,
  maxrows,
  size = 'large',
}: ProductCorePropertiesProps) => {
  return (
    <PropertyList
      className={className}
      toneDown={toneDown}
      maxRows={maxrows}
      size={size}
    >
      {properties ? (
        properties.filter(v => v).join(', ')
      ) : (
        <PlaceholderProperty toneDown={toneDown} size={size} />
      )}
    </PropertyList>
  );
};
